import { signInWithPopup, OAuthProvider, User } from 'firebase/auth';
import { auth } from '../config/firebase';

export interface AppleAuthResponse {
  user: User;
  idToken?: string;
}

export const signInWithApple = async (): Promise<AppleAuthResponse> => {
  // Apple uses a generic OAuth provider in Firebase
  const provider = new OAuthProvider('apple.com');
  provider.addScope('email');
  provider.addScope('name');

  try {
    const result = await signInWithPopup(auth, provider);
    const user = result.user;

    const idToken = await user.getIdToken();

    return {
      user,
      idToken,
    };
  } catch (error: any) {
    console.error('Apple sign-in error:', error);
    if (error.code === 'auth/account-exists-with-different-credential') {
      throw new Error('An account already exists with different sign-in credentials.');
    }
    throw new Error(error.message || 'Failed to sign in with Apple');
  }
};

export const signOutApple = async (): Promise<void> => {
  const { signOut } = await import('firebase/auth');
  await signOut(auth);
}; 